import { Controller } from "@hotwired/stimulus";
import {Modal} from "bootstrap5";

export default class extends Controller {
  submitId(event) {
    if (event.params.hide) {
      $(event.params.hide).addClass("d-none");
    }
    if (event.params.show) {
      $(event.params.show).removeClass("d-none");
    }

    if (event.params.toggle) {
      $(event.params.toggle).prop("checked", !$(event.params.toggle).prop("checked"));
    }

    if(event.params.dismiss){
      Modal.getInstance(event.params.dismiss)?.hide();
    }

    $(event.params.formId)[0].requestSubmit();

    //Turbo.navigator.submitForm($(event.params.formId)[0])
  }
}
